<template>
  <v-flex x12>
    <h2 class="nx-heading--level-1" v-text="title"/>
    <v-radio-group :value="value" @change="onInput" v-if="availableTools.length > 0">
      <v-radio
        v-for="tool in availableTools"
        :key="tool.value"
        :label="tool.text | translate"
        :value="tool"
      />
    </v-radio-group>
    <nx-dashboard-info-message
      v-else
      :title="$t('message.dashboard.shortcuts.wizard.error.ups')"
      :text="$t('message.dashboard.shortcuts.wizard.error.emptyAvailableTools')"
    />
  </v-flex>
</template>

<script>
import NxDashboardInfoMessage from '@/modules/dashboard/components/DashboardInfoMessage.vue';

export default {
  name: 'dashboard-shortcut-wizard-tools-access-action',
  components: { NxDashboardInfoMessage },
  props: {
    wizardConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      value: null,
    };
  },
  computed: {
    availableTools() {
      if (this.wizardConfig.availableTools
        && Array.isArray(this.wizardConfig.availableTools)
      ) {
        // Available tools configured in API.
        return this.wizardConfig.availableTools;
      }

      return [];
    },
    title() {
      return this.$t('message.dashboard.shortcuts.wizard.title.filterResourceAccess', {
        resource: this.$tc('message.dashboard.shortcuts.resource.tools'),
      });
    },
  },
  methods: {
    onInput(tool) {
      this.value = tool;

      if (!tool) {
        this.$emit('input', null);
        return;
      }

      const url = tool.url || this.$router.resolve({
        name: 'searcher',
        params: {
          entity: tool.value,
        },
      }).href;

      this.$emit('input', {
        url,
        type: tool.value,
        text: tool.text,
        icon: tool.icon,
      });
    },
  },
};
</script>
